export default __webpack_public_path__ + "static/media/mask2.5e36120a.jpeg";